(function () {
  const cartHiddenVariants = new Map();
  let syncTimer;

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      const moneyFormat =
        window.theme?.moneyFormat ||
        window.Shopify?.money_format ||
        'R$ {{amount_with_comma_separator}}';
      return Shopify.formatMoney(cents, moneyFormat);
    }

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format((Number(cents) || 0) / 100);
  }

  function getEffectiveCompare(variantPrice, variantCompare, bundleCompare) {
    const compareAt = Number(variantCompare || 0);
    const bundle = Number(bundleCompare || 0);
    if (compareAt > variantPrice) return compareAt;
    if (bundle > variantPrice) return bundle;
    return 0;
  }

  function parseVariants(item) {
    const jsonEl = item.querySelector('[data-variants-json]');
    if (!jsonEl) return [];

    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      console.error('compre-junto: failed to parse variants JSON', error);
      return [];
    }
  }

  function getOptionValue(variant, position) {
    if (!variant || !position) return '';
    if (position === 1) return variant.option1 || '';
    if (position === 2) return variant.option2 || '';
    if (position === 3) return variant.option3 || '';
    return '';
  }

  function getPositions(item) {
    return {
      color: Number.parseInt(item.dataset.colorPosition || '0', 10) || 0,
      size: Number.parseInt(item.dataset.sizePosition || '0', 10) || 0,
    };
  }

  function getSelectedColor(item) {
    const active = item.querySelector('[data-compre-junto-color-swatch].is-active');
    return active?.dataset.color || '';
  }

  function getSelectedSize(item) {
    const select = item.querySelector('[data-compre-junto-size-select]');
    return select?.value || '';
  }

  function findVariant(variants, color, size, positions) {
    return (
      variants.find(function (variant) {
        if (variant.available === false) return false;
        if (positions.color && color && getOptionValue(variant, positions.color) !== color) return false;
        if (positions.size && size && getOptionValue(variant, positions.size) !== size) return false;
        return true;
      }) || null
    );
  }

  function parseColorChannels(color) {
    if (!color) return null;
    const value = String(color).trim();
    if (value.startsWith('rgb')) {
      const nums = value.match(/\d+/g);
      if (!nums || nums.length < 3) return null;
      return { r: Number(nums[0]), g: Number(nums[1]), b: Number(nums[2]) };
    }

    const clean = value.replace('#', '');
    if (clean.length !== 6) return null;
    return {
      r: Number.parseInt(clean.slice(0, 2), 16),
      g: Number.parseInt(clean.slice(2, 4), 16),
      b: Number.parseInt(clean.slice(4, 6), 16),
    };
  }

  function isLightColor(color) {
    const channels = parseColorChannels(color);
    if (!channels) return false;
    return 0.299 * channels.r + 0.587 * channels.g + 0.114 * channels.b > 186;
  }

  // ZUCK 2026-10-14: WCAG contrast of the fill vs the white page; below 1.5:1 -> dark outline (btn--light-fill).
  function isTooLightForPage(color) {
    const ch = parseColorChannels(color);
    if (!ch) return false;
    const lin = [ch.r, ch.g, ch.b].map(function (v) {
      v = v / 255;
      return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    const L = 0.2126 * lin[0] + 0.7152 * lin[1] + 0.0722 * lin[2];
    return 1.05 / (L + 0.05) < 1.5;
  }

  // ZUCK 2026-10-14: the swatch row is one line now; bring the active dot into view without moving the page.
  function revealActiveSwatch(item) {
    const row = item.querySelector('.compre-junto-card__swatches');
    const active = row && row.querySelector('.compre-junto-card__swatch-btn.is-active');
    if (!row || !active || row.scrollWidth <= row.clientWidth) return;
    const li = active.closest('li') || active;
    const left = li.offsetLeft;
    const right = left + li.offsetWidth;
    if (right > row.scrollLeft + row.clientWidth) row.scrollLeft = right - row.clientWidth + 8;
    else if (left < row.scrollLeft) row.scrollLeft = Math.max(0, left - 8);
  }

  // ZUCK 2026-10-14 (item 14): fade cue on the one-line swatch row.
  function updateSwatchFade(row) {
    const max = row.scrollWidth - row.clientWidth;
    const canLeft = max > 2 && row.scrollLeft > 2;
    const canRight = max > 2 && row.scrollLeft < max - 2;
    row.classList.toggle('cj-can-left', canLeft);
    row.classList.toggle('cj-can-right', canRight);
    const wrap = row.closest('[data-cj-swatch-row]');
    if (wrap) {
      wrap.classList.toggle('cj-can-left', canLeft);
      wrap.classList.toggle('cj-can-right', canRight);
    }
  }

  function initSwatchFade(item) {
    const row = item.querySelector('.compre-junto-card__swatches');
    if (!row) return;
    let queued = false;
    const schedule = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; updateSwatchFade(row); });
    };
    row.addEventListener('scroll', schedule, { passive: true });
    // ZUCK 2026-10-14 (item 17): thin arrows scroll the row by ~3 dots
    const wrap = row.closest('[data-cj-swatch-row]');
    if (wrap) {
      wrap.addEventListener('click', function (event) {
        const nav = event.target.closest('[data-cj-next], [data-cj-prev]');
        if (!nav) return;
        event.preventDefault();
        const dot = row.querySelector('.compre-junto-card__swatch-btn');
        const step = 3 * (dot ? dot.getBoundingClientRect().width : 26);
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        row.scrollBy({ left: nav.hasAttribute('data-cj-next') ? step : -step, behavior: reduce ? 'auto' : 'smooth' });
      });
    }
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule, { once: true });
    schedule();
  }

  function updateItemButtonColor(item) {
    const button = item.querySelector('[data-compre-junto-add]');
    if (!button) return;

    const activeSwatch = item.querySelector('[data-compre-junto-color-swatch].is-active');
    const colorBg = activeSwatch?.dataset.colorBg || '';
    button.classList.toggle('btn--light-fill', isTooLightForPage(colorBg));

    if (colorBg) {
      button.style.setProperty('--variant-button-bg', colorBg);
      if (isLightColor(colorBg)) {
        button.style.setProperty('--variant-button-text', '#1a1a1a');
        button.style.setProperty('--variant-button-text-rgb', '26, 26, 26');
      } else {
        button.style.setProperty('--variant-button-text', '#ffffff');
        button.style.setProperty('--variant-button-text-rgb', '255, 255, 255');
      }
      return;
    }

    button.style.removeProperty('--variant-button-bg');
    button.style.removeProperty('--variant-button-text');
    button.style.removeProperty('--variant-button-text-rgb');
  }

  function getColorImage(item, colorValue) {
    if (!item || !colorValue) return '';
    const swatch = Array.from(item.querySelectorAll('[data-compre-junto-color-swatch]')).find(function (button) {
      return button.dataset.color === colorValue;
    });
    return swatch?.dataset.imageSrc || '';
  }

  function getVariantImage(variant, variants, positions) {
    if (!variant) return '';
    if (variant.image) return variant.image;

    const color = getOptionValue(variant, positions.color);
    if (!color) return '';

    const sameColorVariant = variants.find(function (entry) {
      return entry.available !== false && getOptionValue(entry, positions.color) === color && entry.image;
    });

    return sameColorVariant?.image || '';
  }

  // ZUCK 2026-10-30 Black VS: paint the native price row, then its hidden BF twin (.bfvs-alt, priced data.bf).
  function paintPriceRow(row, price, compareAt, bundleCompare) {
    if (!row) return;
    const effectiveCompare = getEffectiveCompare(price, compareAt, bundleCompare);
    const priceEl = row.querySelector('[data-compre-junto-price]');
    const compareEl = row.querySelector('[data-compre-junto-compare]');
    if (priceEl) priceEl.textContent = formatMoney(price);
    if (compareEl) {
      if (effectiveCompare > price) {
        compareEl.textContent = formatMoney(effectiveCompare);
        compareEl.classList.remove('hidden');
      } else {
        compareEl.textContent = '';
        compareEl.classList.add('hidden');
      }
    }
  }

  function updateItemDisplay(item, data) {
    if (!data) return;

    const bundleCompare = Number(item.getAttribute('data-bundle-compare-at') || 0);
    const bfRow = item.querySelector('.compre-junto-card__price-row.bfvs-alt');
    const bf = Number(data.bf || 0);
    if (bfRow && bf > 0 && bf < data.price) paintPriceRow(bfRow, bf, data.compareAt, bundleCompare);
    const effectiveCompare = getEffectiveCompare(data.price, data.compareAt, bundleCompare);

    const imageEl = item.querySelector('[data-compre-junto-image]');
    const priceEl = item.querySelector('.compre-junto-card__price-row:not(.bfvs-alt) [data-compre-junto-price]');
    const compareEl = item.querySelector('.compre-junto-card__price-row:not(.bfvs-alt) [data-compre-junto-compare]');
    const colorLabel = item.querySelector('[data-compre-junto-color-label]');
    const sizeLabel = item.querySelector('[data-compre-junto-size-label]');
    const titleLink = item.querySelector('[data-compre-junto-title-link]');
    const mediaLink = item.querySelector('[data-compre-junto-media-link]');
    const hiddenInput = item.querySelector('[data-compre-junto-variant-input]');

    if (imageEl && data.image) {
      imageEl.src = data.image;
      imageEl.removeAttribute('srcset');
    }
    if (priceEl) priceEl.textContent = formatMoney(data.price);
    if (hiddenInput) hiddenInput.value = data.id;
    if (titleLink && data.url) titleLink.href = data.url;
    if (mediaLink && data.url) mediaLink.href = data.url;
    if (colorLabel && data.color) colorLabel.textContent = data.color;
    if (sizeLabel && data.size) sizeLabel.textContent = data.size;

    if (compareEl) {
      if (effectiveCompare > data.price) {
        compareEl.textContent = formatMoney(effectiveCompare);
        compareEl.classList.remove('hidden');
      } else {
        compareEl.textContent = '';
        compareEl.classList.add('hidden');
      }
    }
  }

  function rebuildSizeOptions(item, variants, selectedColor) {
    const sizeSelect = item.querySelector('[data-compre-junto-size-select]');
    const positions = getPositions(item);
    if (!sizeSelect || !positions.size) return getSelectedSize(item);

    const sizes = [];
    variants.forEach(function (variant) {
      if (variant.available === false) return;
      const variantColor = getOptionValue(variant, positions.color);
      if (positions.color && selectedColor && variantColor !== selectedColor) return;
      const size = getOptionValue(variant, positions.size);
      if (!size || sizes.includes(size)) return;
      sizes.push(size);
    });

    const previous = sizeSelect.value;
    sizeSelect.innerHTML = '';

    sizes.forEach(function (size) {
      const option = document.createElement('option');
      option.value = size;
      option.textContent = size;
      sizeSelect.appendChild(option);
    });

    if (sizes.includes(previous)) {
      sizeSelect.value = previous;
    } else if (sizes.length) {
      sizeSelect.value = sizes[0];
    }

    return sizeSelect.value || '';
  }

  function setActiveColorSwatch(item, colorValue) {
    item.querySelectorAll('[data-compre-junto-color-swatch]').forEach(function (button) {
      const isActive = button.dataset.color === colorValue;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function resolveAndApplyVariant(item) {
    const variants = parseVariants(item);
    const positions = getPositions(item);
    const color = getSelectedColor(item);
    const size = getSelectedSize(item);
    const variant = findVariant(variants, color, size, positions);

    if (!variant) {
      const addButton = item.querySelector('[data-compre-junto-add]');
      if (addButton) addButton.disabled = true;
      return null;
    }

    const addButton = item.querySelector('[data-compre-junto-add]');
    if (addButton) addButton.disabled = false;

    const image =
      getVariantImage(variant, variants, positions) ||
      getColorImage(item, color) ||
      '';

    updateItemDisplay(item, {
      id: variant.id,
      price: Number(variant.price || 0),
      compareAt: Number(variant.compare_at_price || 0),
      bf: Number(variant.bf || 0),
      image: image,
      url: variant.url || '',
      color: getOptionValue(variant, positions.color),
      size: getOptionValue(variant, positions.size),
    });

    updateItemButtonColor(item);

    return variant;
  }

  function selectColor(item, colorValue) {
    setActiveColorSwatch(item, colorValue);
    rebuildSizeOptions(item, parseVariants(item), colorValue);
    resolveAndApplyVariant(item);
  }

  function selectVariantOption(item, option) {
    if (!option) return;

    if (option.matches('[data-compre-junto-color-swatch]')) {
      selectColor(item, option.dataset.color || '');
      return;
    }

    if (option.matches('option')) {
      updateItemDisplay(item, {
        id: option.dataset.variantId || option.value,
        price: Number(option.dataset.price || 0),
        compareAt: Number(option.dataset.compareAt || 0),
        bf: Number(option.dataset.bf || 0),
        image: option.dataset.image || '',
        url: option.dataset.url || '',
        label: option.dataset.label || option.textContent.trim(),
      });
    }
  }

  function initColorSwatches(item) {
    item.querySelectorAll('[data-compre-junto-color-swatch]').forEach(function (button) {
      if (button.getAttribute('data-swatch-ready') === 'true') return;
      button.addEventListener('click', function (event) {
        event.preventDefault();
        selectColor(item, button.dataset.color || '');
      });
      button.setAttribute('data-swatch-ready', 'true');
    });
  }

  function initSizeSelect(item) {
    const sizeSelect = item.querySelector('[data-compre-junto-size-select]');
    if (!sizeSelect || sizeSelect.getAttribute('data-size-ready') === 'true') return;

    sizeSelect.addEventListener('change', function () {
      resolveAndApplyVariant(item);
    });
    sizeSelect.setAttribute('data-size-ready', 'true');
  }

  function initVariantSelect(item) {
    const variantSelect = item.querySelector('[data-compre-junto-variant-select]');
    if (!variantSelect || variantSelect.getAttribute('data-variant-ready') === 'true') return;

    variantSelect.addEventListener('change', function () {
      const option = variantSelect.selectedOptions[0];
      if (option) selectVariantOption(item, option);
    });
    variantSelect.setAttribute('data-variant-ready', 'true');
  }

  function initAddButton(item) {
    const addButton = item.querySelector('[data-compre-junto-add]');
    if (!addButton || addButton.getAttribute('data-add-ready') === 'true') return;

    addButton.addEventListener('click', async function () {
      const variantId = item.querySelector('[data-compre-junto-variant-input]')?.value;
      if (!variantId || addButton.disabled) return;

      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');

      try {
        await addVariantToCart(Number.parseInt(variantId, 10));
      } catch (error) {
        console.error(error);
        addButton.disabled = false;
      } finally {
        addButton.removeAttribute('aria-busy');
      }
    });

    addButton.setAttribute('data-add-ready', 'true');
  }

  function initItem(item) {
    if (item.getAttribute('data-compre-junto-initialized') === 'true') return;

    initColorSwatches(item);
    initSizeSelect(item);
    initVariantSelect(item);
    initAddButton(item);

    const positions = getPositions(item);
    if (positions.color) {
      rebuildSizeOptions(item, parseVariants(item), getSelectedColor(item));
    }

    resolveAndApplyVariant(item);

    const mediaLink = item.querySelector('[data-compre-junto-media-link]');
    if (mediaLink) mediaLink.style.removeProperty('aspect-ratio');

    revealActiveSwatch(item);
    window.addEventListener('load', function () { revealActiveSwatch(item); }, { once: true });
    initSwatchFade(item);

    item.setAttribute('data-compre-junto-initialized', 'true');
  }

  function getListItems(root) {
    return Array.from(root.querySelectorAll('[data-compre-junto-item]')).filter(
      (item) => !item.hasAttribute('data-compre-junto-hidden')
    );
  }

  function initRoot(root) {
    if (!root) return;
    root.querySelectorAll('[data-compre-junto-item]').forEach(initItem);
    root.setAttribute('data-compre-junto-ready', 'true');
    refreshSectionVisibility(root);
  }

  function initAll(scope) {
    const container = scope && scope.querySelectorAll ? scope : document;
    container.querySelectorAll('[data-compre-junto]').forEach(initRoot);
  }

  function getSelectedItems() {
    return [];
  }

  function mergeSelectedItems(baseItems) {
    return Array.isArray(baseItems) ? baseItems.slice() : [];
  }

  function refreshSectionVisibility(root) {
    const visibleCount = getListItems(root).length;
    const block = root.closest('.compre-junto-block');
    const section = root.closest('.product-compre-junto-section');
    const host = root.closest('product-recommendations');

    if (visibleCount > 0) {
      block?.removeAttribute('hidden');
      section?.removeAttribute('hidden');
      host?.removeAttribute('hidden');
    } else {
      block?.setAttribute('hidden', '');
      section?.setAttribute('hidden', '');
      host?.setAttribute('hidden', '');
    }
  }

  function hideItemInList(item, variantId) {
    const id = String(variantId);
    const productId = item.getAttribute('data-product-id') || '';
    cartHiddenVariants.set(id, productId);
    item.setAttribute('data-compre-junto-hidden', 'cart');
    item.setAttribute('data-compre-junto-hidden-variant', id);
  }

  function showItemInList(item) {
    item.removeAttribute('data-compre-junto-hidden');
    item.removeAttribute('data-compre-junto-hidden-variant');
  }

  function findItemsForVariant(variantId) {
    const id = String(variantId);
    const items = new Set();
    document.querySelectorAll('[data-compre-junto-item][data-compre-junto-hidden-variant="' + id + '"]').forEach((item) => {
      items.add(item);
    });
    document.querySelectorAll('[data-compre-junto-variant-input][value="' + id + '"]').forEach((input) => {
      const item = input.closest('[data-compre-junto-item]');
      if (item) items.add(item);
    });
    const productId = cartHiddenVariants.get(id);
    if (productId) {
      document.querySelectorAll('[data-compre-junto-item][data-product-id="' + productId + '"]').forEach((item) => {
        items.add(item);
      });
    }
    return Array.from(items);
  }

  function reinitAllRoots() {
    document.querySelectorAll('[data-compre-junto]').forEach((root) => {
      root.removeAttribute('data-compre-junto-ready');
      initRoot(root);
    });
  }

  function hideVariantsById(variantIds) {
    if (!variantIds || !variantIds.size) return;

    variantIds.forEach((variantId) => {
      findItemsForVariant(variantId).forEach((item) => {
        hideItemInList(item, variantId);
      });
    });

    reinitAllRoots();
  }

  async function fetchFreshCart() {
    const response = await fetch(window.Shopify.routes.root + 'cart.js?ts=' + Date.now(), {
      method: 'GET',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
      },
    });
    if (!response.ok) return null;
    return response.json();
  }

  function getCartVariantIds(cart) {
    if (!cart || !Array.isArray(cart.items)) return new Set();
    return new Set(cart.items.map((item) => String(item.variant_id || item.id)));
  }

  function collectTrackedVariantsFromDom() {
    document.querySelectorAll('[data-compre-junto-item][data-compre-junto-hidden="cart"]').forEach((item) => {
      const variantId =
        item.getAttribute('data-compre-junto-hidden-variant') ||
        item.querySelector('[data-compre-junto-variant-input]')?.value;
      if (!variantId) return;
      cartHiddenVariants.set(String(variantId), item.getAttribute('data-product-id') || '');
    });
  }

  function applyCartHiddenState(cart) {
    if (!document.querySelector('[data-compre-junto]')) return;

    collectTrackedVariantsFromDom();
    if (!cartHiddenVariants.size) return;

    const inCart = getCartVariantIds(cart);
    let changed = false;

    Array.from(cartHiddenVariants.keys()).forEach((variantId) => {
      if (inCart.has(variantId)) return;

      cartHiddenVariants.delete(variantId);
      findItemsForVariant(variantId).forEach((item) => {
        showItemInList(item);
        changed = true;
      });
    });

    if (!changed) return;
    reinitAllRoots();
  }

  function restoreVariantIfHidden(variantId) {
    const id = String(variantId);
    const isTracked =
      cartHiddenVariants.has(id) ||
      document.querySelector('[data-compre-junto-item][data-compre-junto-hidden-variant="' + id + '"]');

    if (!isTracked) return false;

    cartHiddenVariants.delete(id);
    let changed = false;
    findItemsForVariant(id).forEach((item) => {
      showItemInList(item);
      changed = true;
    });

    if (!changed) return false;
    reinitAllRoots();
    return true;
  }

  async function syncCartHiddenState(cartData) {
    if (cartData && Array.isArray(cartData.items)) {
      applyCartHiddenState(cartData);
      return;
    }

    const cart = await fetchFreshCart();
    if (cart) applyCartHiddenState(cart);
  }

  function scheduleCartSync(cartData) {
    if (!document.querySelector('[data-compre-junto]')) return;

    if (cartData && Array.isArray(cartData.items)) {
      applyCartHiddenState(cartData);
      return;
    }

    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(() => {
      syncCartHiddenState();
    }, 0);
  }

  async function reapplyHiddenFromCart() {
    if (!cartHiddenVariants.size) return;

    const cart = await fetchFreshCart();
    if (!cart) return;

    const inCart = getCartVariantIds(cart);
    let changed = false;

    cartHiddenVariants.forEach((productId, variantId) => {
      if (!inCart.has(variantId)) return;

      const targets = productId
        ? Array.from(document.querySelectorAll('[data-compre-junto-item][data-product-id="' + productId + '"]'))
        : findItemsForVariant(variantId);

      targets.forEach((item) => {
        if (item.hasAttribute('data-compre-junto-hidden')) return;
        hideItemInList(item, variantId);
        changed = true;
      });
    });

    if (!changed) return;
    reinitAllRoots();
  }

  function onCartAddSuccess(compreItems) {
    if (!Array.isArray(compreItems) || !compreItems.length) return;
    hideVariantsById(new Set(compreItems.map((item) => item.id)));
  }

  async function addVariantToCart(variantId) {
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const sectionIds =
      cart && typeof cart.getSectionsToRender === 'function'
        ? cart.getSectionsToRender().map((section) => section.id)
        : ['cart-drawer', 'cart-icon-bubble'];

    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });

    const responseJson = await response.json();
    if (!response.ok) {
      throw new Error(responseJson.description || responseJson.message || 'Erro ao adicionar Compre Junto.');
    }

    onCartAddSuccess([{ id: variantId, quantity: 1 }]);

    if (cart && typeof cart.renderContents === 'function') {
      cart.renderContents(responseJson);
      cart.classList.remove('is-empty');
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'compre-junto',
        cartData: responseJson,
      });
    }

    return responseJson;
  }

  function hookCartRestore() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (!event || event.source === 'compre-junto' || event.source === 'product-form') return;
        scheduleCartSync(event.cartData);
      });
    }

    document.addEventListener(
      'click',
      (event) => {
        const removeButton = event.target.closest('.cart-remove-button');
        if (!removeButton) return;
        const variantId = removeButton.getAttribute('data-variant-id');
        if (variantId) restoreVariantIfHidden(variantId);
      },
      true
    );

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (
        !target ||
        (!target.matches('.quantity__input') && !target.matches('[name="updates[]"]')) ||
        (!target.closest('cart-drawer-items') && !target.closest('cart-items'))
      ) {
        return;
      }

      const qty = Number.parseInt(target.value, 10);
      if (qty !== 0) return;

      const variantId = target.getAttribute('data-quantity-variant-id');
      if (variantId) restoreVariantIfHidden(variantId);
    });
  }

  window.CompreJunto = {
    initAll,
    initItem,
    selectVariantOption,
    selectColor,
    updateItemDisplay,
    getSelectedItems,
    mergeSelectedItems,
    onCartAddSuccess,
    hideVariantsById,
    syncCartHiddenState,
    addVariantToCart,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAll(document);
      hookCartRestore();
    });
  } else {
    initAll(document);
    hookCartRestore();
  }

  document.addEventListener('recommendations:loaded', (event) => {
    const container = event.detail?.container || document;
    initAll(container);
    reapplyHiddenFromCart();
  });
})();
